
import { Options, Vue } from 'vue-class-component'

@Options({
  components: {},
  props: ['showTableFieldKeys'],
  emits: {
    click: null,
    showtablefield: () => {
      return true
    }
  }
})
export default class TableFieldShow extends Vue {
}
